import React from 'react';
import SelectBase, { ISelectCommonProps } from './base/SelectBase';
import { SelectItem } from 'src/models/common/SelectItem';

interface ISelectProps extends ISelectCommonProps {
    label?: string;
    items?: SelectItem[];
    onChange?: (item: SelectItem) => void;
}

const Select: React.FC<ISelectProps> = (props) => {
    return <SelectBase {...props} />;
};

export default Select;



// WEBPACK FOOTER //
// ./src/components/controls/forms/Select.tsx